import React from 'react';
import { Redirect } from 'react-router';
import { UserTacksShape, UserShape, SubscriptionShape } from '../shapes';
import DateMaster from '../stores/utils/date_master';
import AccountTacks from './account_tacks';
import AccountSubscription from './account_subscription';
import AccountFree from './account_free';
import AccountDangerZone from './account_danger_zone';
import AccountFollowing from './account_following';
import AccountNotificationPreferences from './account_notification_preferences';

export default class Account extends React.Component {
  static propTypes = {
    user: UserShape,
    subscription: SubscriptionShape,
    userTacks: UserTacksShape
  }

  render() {
    if (this.props.user.get('loggedIn')) {
      return (
        <div className='row account'>
          <div className='offset-sm-2 col-sm-8'>
          <div className='header'>
            <h1>Account</h1>
            <p className='item-meta'>
              { this.props.user.get('email') }
              <span className='dot-spacer'></span>
              since { DateMaster.format(this.props.user.get('createdAt')) }
            </p>
          </div>
            { this.renderSubscription() }
            { this.renderAccountTacks() }
            { this.renderFollowing() }
            { this.renderNotificationPreferences() }
            { this.renderDeleteAccountOption() }
          </div>
        </div>
      )
    } else {
      return (
        <Redirect push to={ '/' } />
      )
    }
  }

  renderAccountTacks() {
    return (
      <AccountTacks user={ this.props.user } />
    )
  }

  renderFollowing() {
    return (
      <AccountFollowing user={ this.props.user } />
    );
  }

  renderSubscription() {
    if (this.props.subscription.get('active')) {
      return (
        <AccountSubscription />
      );
    } else {
      return (
        <AccountFree />
      );
    }
  }

  renderNotificationPreferences() {
    return (
      <AccountNotificationPreferences />
    )
  }

  renderDeleteAccountOption() {
    return (
      <AccountDangerZone user={ this.props.user }/>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/account.jsx